(() => {
if(document.documentElement.dataset.slFinder) return;
const config=document.getElementById('sl-size-config');
if(!config) return;
document.documentElement.dataset.slFinder='true';
const {strings:t,variants}=JSON.parse(config.textContent);
for(const v of variants){v.size=v.options.find(o=>['XS','S','M','L','XL','2XL','3XL','Custom'].includes(o));v.height=v.options.find(o=>o==='Regular'||o.startsWith('Tall'))||'';}
function matchingVariant(){
const matches=variants.filter(v=>v.size===result.size&&(v.height?result.tall?v.height.startsWith('Tall'):v.height==='Regular':!result.tall||result.size==='Custom'));
const selected=[...document.querySelectorAll('#MainContent variant-picker input:checked')].map(i=>i.value);
return matches.sort((a,b)=>b.options.filter(o=>selected.includes(o)).length-a.options.filter(o=>selected.includes(o)).length)[0];
}
const storageKey='sl-fit-'+JSON.parse(config.textContent).productId;
let submitted;
try{const saved=JSON.parse(sessionStorage.getItem(storageKey));if(saved&&Date.now()-saved.time<7200000)submitted=saved;}catch{}
function persistMeasurements(){
submitted={time:Date.now(),height:state.feet+' ft '+state.inches+' in',chest:state.chest+' in',belly:state.belly+' in',fit:state.fit,recommended:result.size+(result.size==='Custom'?'':result.tall?' — Tall':' — Regular')};
try{sessionStorage.setItem(storageKey,JSON.stringify(submitted));}catch{}
attachMeasurements();
}
function attachMeasurements(){
if(!submitted)return;
const values={'Height':submitted.height,'Chest circumference':submitted.chest,'Belly circumference':submitted.belly,'Fit preference':submitted.fit,'Recommended size':submitted.recommended};
for(const form of document.querySelectorAll('#MainContent form[action*="/cart/add"]')){
for(const [key,value] of Object.entries(values)){
const name='properties['+key+']';let input=[...form.elements].find(e=>e.name===name);
if(!input){input=document.createElement('input');input.type='hidden';input.name=name;form.append(input);}
if(input.value!==value)input.value=value;
}
}
}
const dialog=document.getElementById('sl-size-dialog'),content=document.getElementById('sl-size-content'),heading=document.getElementById('sl-size-heading'),error=document.getElementById('sl-size-error'),progress=document.getElementById('sl-size-progress'),next=dialog.querySelector('[data-sl-next]'),back=dialog.querySelector('[data-sl-back]');
document.body.append(dialog);
const sizes=['XS','S','M','L','XL','2XL','3XL'];
const chestRanges=[[32,35],[36,37],[38,40],[41,44],[45,48],[49,52],[53,56]];
const bellyRanges=[[26,29],[29,31],[32,34],[35,38],[40,42],[43,46],[47,50]];
let step=0,state={feet:'',inches:'0',chest:'',belly:'',fit:'regular'},result,opener;
const esc=v=>String(v).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
function index(value,ranges,relaxed){
const matches=ranges.map((r,i)=>value>=r[0]&&value<=r[1]?i:-1).filter(i=>i>=0);
if(matches.length) return relaxed?matches.at(-1):matches[0];
const upper=ranges.findIndex(r=>value<r[0]);
return relaxed?upper:upper-1;
}
function recommend(){
const chest=Number(state.chest),belly=Number(state.belly),tall=Number(state.feet)*12+Number(state.inches)>72,relaxed=state.fit==='relaxed';
if(state.fit==='custom'||belly>chest||chest<32||chest>56||belly<26||belly>50) return {size:'Custom',tall};
const c=index(chest,chestRanges,relaxed),w=index(belly,bellyRanges,relaxed);
let chosen;
const loose=chest-belly>12;
if(loose) chosen=index(chest,chestRanges,false);
else if(c!==w) chosen=relaxed?Math.max(c,w):Math.min(c,w);
else {
const gap=![chestRanges[c],bellyRanges[w]].every((r,i)=>(i?belly:chest)>=r[0]&&(i?belly:chest)<=r[1]);
chosen=Math.min(6,c+(relaxed&&!gap?1:0));
}
return {size:sizes[Math.max(0,chosen)],tall,loose};
}
function field(name,label,value,min,max,increment){
return '<label>'+esc(label)+'<input id="sl-'+name+'" data-sl-field="'+name+'" type="number" inputmode="decimal" min="'+min+'" max="'+max+'" step="'+increment+'" value="'+esc(value)+'" required></label>';
}
function render(){
error.textContent='';next.disabled=false;back.hidden=step===0;progress.textContent=step<4?t.step+' '+(step+1)+' '+t.of+' 4':'';
next.textContent=step===4?t.select:t.next;back.textContent=step===4?t.restart:t.back;
if(step===0){heading.textContent=t.height;content.innerHTML='<p>'+esc(t.height_help)+'</p><div class="sl-size-fields">'+field('feet',t.feet,state.feet,3,8,1)+field('inches',t.inches,state.inches,0,11.99,.1)+'</div>';}
if(step===1||step===2){const name=step===1?'chest':'belly';heading.textContent=t[name];content.innerHTML='<p>'+esc(t[name+'_help'])+'</p>'+field(name,t.inches,state[name],15,100,.1);}
if(step===3){heading.textContent=t.fit;content.innerHTML=['regular','relaxed','custom'].map(v=>'<label class="sl-size-choice"><input type="radio" name="sl-fit" value="'+v+'" '+(state.fit===v?'checked':'')+'><span>'+esc(v==='custom'?t.custom_option:t[v])+(v==='custom'?'':'<small>'+esc(t[v+'_help'])+'</small>')+'</span></label>').join('');}
if(step===4){
result=recommend();heading.textContent=result.size==='Custom'?t.custom_heading:t.result;
persistMeasurements();
const cut=result.tall?t.cut_tall:t.cut_regular;
content.innerHTML='<div class="sl-size-result">'+esc(result.size==='Custom'?t.custom:result.size+' — '+cut)+'</div><p>'+esc(result.size==='Custom'?t.custom_help:result.loose?t.loose:t.normal)+'</p><p class="sl-size-summary">'+esc(state.chest)+'″ '+esc(t.chest_label)+'<br>'+esc(state.belly)+'″ '+esc(t.belly_label)+'</p>';
const variant=matchingVariant();
if(!variant?.available){error.textContent=t.unavailable;next.disabled=true;}
}
heading.setAttribute('tabindex','-1');heading.focus();
}
function save(){
for(const input of content.querySelectorAll('[data-sl-field]')){
if(input.value.trim()===''||!input.checkValidity()){error.textContent=t.invalid;input.focus();return false;}
state[input.dataset.slField]=input.value;
}
if(step===3) state.fit=content.querySelector('input:checked')?.value||'regular';
return true;
}
function close(){dialog.close();document.body.style.overflow='';opener?.focus();}
document.addEventListener('click',e=>{
const trigger=e.target.closest('[data-sl-open]');
if(trigger){e.preventDefault();e.stopImmediatePropagation();opener=trigger;step=0;render();dialog.showModal();document.body.style.overflow='hidden';}
},true);
dialog.querySelector('[data-sl-close]').addEventListener('click',close);
dialog.addEventListener('cancel',e=>{e.preventDefault();close();});
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom) close();}});
dialog.addEventListener('keydown',e=>{if(e.key==='Enter'&&e.target.matches('input[type=number]')){e.preventDefault();next.click();}});
next.addEventListener('click',()=>{
if(step<4){if(!save())return;step++;render();return;}
const variant=matchingVariant();
if(!variant?.available)return;
const url=new URL(location.href);url.searchParams.set('variant',variant.id);location.assign(url.href);
});
back.addEventListener('click',()=>{if(step===4) step=0;else{save();step--;}render();});
function attach(){
attachMeasurements();
for(const block of document.querySelectorAll('#MainContent [data-sl-finder-block]')){
const button=block.querySelector('[data-sl-open]');
if(!button||block.dataset.slPlacement!=='chart')continue;
const chart=document.querySelector('#MainContent .jsc-size-chart-button');
if(!chart)continue;
let row=chart.closest('.sl-size-links');
if(!row){row=document.createElement('div');row.className='sl-size-links';chart.before(row);row.append(chart);}
if(row.querySelector('[data-sl-open]'))button.hidden=true;else row.append(button);
}
for(const duplicate of document.querySelectorAll('#MainContent #sl-size-dialog'))duplicate.remove();
const picker=document.querySelector('#MainContent variant-picker');
const custom=picker&&[...picker.querySelectorAll('input[type=radio]:checked')].some(i=>i.value==='Custom');
const note=document.getElementById('sl-custom-note');
if(picker&&note){note.hidden=!custom;if(note.parentElement!==picker.parentElement)picker.after(note);}
}
let scheduled=false;
const scope=document.querySelector('#MainContent variant-picker')?.closest('[id^="ProductInformation-"]')||document.getElementById('MainContent');
if(scope)new MutationObserver(()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(()=>{scheduled=false;attach();});}).observe(scope,{childList:true,subtree:true});
document.addEventListener('submit',attachMeasurements,true);
dialog.addEventListener('change',e=>{if(e.target.matches('input[name="sl-fit"]')&&e.target.value==='custom'){state.fit='custom';step=4;render();}});
document.addEventListener('change',attach);attach();
})();
